import Vue from "vue";
import Vuex from "vuex";

import walletModule from "./modules/wallets/index";
import transactionModule from "./modules/transactions/index";
import referralModule from "./modules/referrals/index";
import templateModule from "./modules/templates/index";
import contactModule from "./modules/contacts/index";
import sentModule from "./modules/sent/index";
import senderidModule from "./modules/senderIds/index";
import smsModule from "./modules/sms/index";
import notificationModule from "./modules/notifications/index";
import groupModule from "./modules/groups/index";
import memberModule from "./modules/members/index";
import sendModule from "./modules/send/index";
import csvModule from "./modules/csvs/index";

import getters from "./getters.js";
import mutations from "./mutations.js";
import actions from "./actions.js";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    wallets: walletModule,
    transactions: transactionModule,
    referrals: referralModule,
    templates: templateModule,
    contacts: contactModule,
    sent: sentModule,
    senderids: senderidModule,
    sms: smsModule,
    notifications: notificationModule,
    groups: groupModule,
    members: memberModule,
    send: sendModule,
    csvs: csvModule,
  },
  state: {
    user: null,
    linkToCopy: "https://flybysms-app.vercel.app/",
    snackbar: {
      show: false,
      text: "",
      color: "",
    },
    progressbar: {
      show: false,
      color: "hover",
    },
    loading: {
      //AUTH
      registerBtn: {
        disabled: false,
        load: false,
      },
      registerCompleteBtn: {
        disabled: false,
        load: false,
      },
      loginBtn: {
        disabled: false,
        load: false,
      },
      forgotBtn: {
        disabled: false,
        load: false,
        proceed: false,
      },
      resetBtn: {
        disabled: false,
        load: false,
      },
      updateMeBtn: {
        disabled: false,
        load: false,
      },
      updatePasswordBtn: {
        disabled: false,
        load: false,
      },
      //TRANSACTIONS
      depositBtn: {
        disabled: false,
        load: false,
      },
      withdrawBtn: {
        disabled: false,
        load: false,
      },
      swapBtn: {
        disabled: false,
        load: false,
      },
      //SMS
      templateBtn: {
        disabled: false,
        load: false,
      },
      templateUpdateBtn: {
        disabled: false,
        load: false,
      },
      //CONTACTS
      createContactBtn: {
        disabled: false,
        load: false,
      },
      contactUpdateBtn: {
        disabled: false,
        load: false,
      },
      //GROUPS
      createGroupBtn: {
        disabled: false,
        load: false,
      },
      updateGroupBtn: {
        disabled: false,
        load: false,
      },
      //MEMBERS
      addMemberBtn: {
        disabled: false,
        load: false,
      },
      updateMemberBtn: {
        disabled: false,
        load: false,
      },
      //SEND
      sendBtn: {
        disabled: false,
        load: false,
      },
      //Schedule
      scheduleBtn: {
        disabled: false,
        load: false,
      },
      //CSV
      uploadCSVBtn: {
        disabled: false,
        load: false,
      },
      //CSV
      senderIdRequestBtn: {
        disabled: false,
        load: false,
      },
    },
  },
  getters,
  mutations,
  actions,
});
